<template>
  <div class="article-view-page">
    <div v-loading="loading"
         class="article-view">
      <div v-if="errorMessage"
           class="article-error">{{ errorMessage }}</div>
      <article v-else
               v-html="articleHtml"
               class="article-content"></article>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArticleView',
  data() {
    return {
      loading: false,
      articleHtml: '',
      errorMessage: ''
    }
  },
  mounted() {
    this.loadArticle()
  },
  methods: {
    loadArticle() {
      const filename = this.$route.params.filename
      if (!filename) {
        this.errorMessage = '文章不存在或已被删除'
        return
      }
      this.loading = true
      const url = '/manage/carousel/article/' + filename
      this.$http.get(url, { responseType: 'text' }).then(res => {
        // res.data 为 HTML 原文
        const html = typeof res.data === 'string' ? res.data : (res.data && res.data.toString()) || ''
        this.articleHtml = html
        this.errorMessage = ''
      }).catch(err => {
        this.errorMessage = '文章不存在或已被删除'
        console.log('加载文章失败', err)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
/* 页面背景：与全站主题一致（米色纸纹） */
.article-view-page {
  min-height: 600px;
  background: #f7efe7;
  padding: 32px 0 48px;
}

/* 文章容器：居中白底卡片 */
.article-view {
  width: 1160px;
  margin: 0 auto;
  background: #fff;
  padding: 48px 64px;
  min-height: 500px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px rgba(158, 92, 29, 0.08);
  border-radius: 4px;
}

/* 文章正文：与全站排版一致 */
.article-content {
  max-width: 860px;
  margin: 0 auto;
  color: #634c37;
  font-size: 16px;
  line-height: 1.8;
  font-family: myhei, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  text-align: justify;
}

/* 标题：主题棕色 + 宋体 */
.article-content >>> h1,
.article-content >>> h2,
.article-content >>> h3,
.article-content >>> h4,
.article-content >>> h5,
.article-content >>> h6 {
  color: #9e5c1d;
  font-family: mysong, 'Songti SC', 'SimSun', '宋体', serif;
  font-weight: bold;
  margin: 1.6em 0 0.8em;
  line-height: 1.4;
}
.article-content >>> h1 {
  font-size: 30px;
  text-align: center;
  margin-top: 0;
  padding-bottom: 16px;
  border-bottom: 1px solid #dfc6b2;
}
.article-content >>> h2 {
  font-size: 24px;
  padding-left: 12px;
  border-left: 4px solid #9e5c1d;
}
.article-content >>> h3 { font-size: 20px; }
.article-content >>> h4 { font-size: 18px; }
.article-content >>> h5,
.article-content >>> h6 { font-size: 16px; }

/* 正文段落 */
.article-content >>> p {
  margin: 0 0 1em;
  text-indent: 2em;
}
.article-content >>> p:empty { display: none; }

/* 图片：居中、带圆角阴影 */
.article-content >>> img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 16px auto;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
}

/* 引用块 */
.article-content >>> blockquote {
  margin: 1.2em 0;
  padding: 12px 20px;
  background: #f7f2ee;
  border-left: 4px solid #9e5c1d;
  color: #634c37;
  font-style: normal;
}
.article-content >>> blockquote p {
  text-indent: 0;
  margin: 0;
}

/* 列表 */
.article-content >>> ul,
.article-content >>> ol {
  padding-left: 2em;
  margin: 0 0 1em;
}
.article-content >>> li { margin: 0.3em 0; }

/* 表格 */
.article-content >>> table {
  width: 100%;
  border-collapse: collapse;
  margin: 1.2em 0;
  font-size: 15px;
}
.article-content >>> th,
.article-content >>> td {
  border: 1px solid #dfc6b2;
  padding: 8px 12px;
  text-align: left;
}
.article-content >>> th {
  background: #f7f2ee;
  color: #9e5c1d;
  font-weight: bold;
}
.article-content >>> tr:nth-child(even) td {
  background: #fbf8f4;
}

/* 链接 */
.article-content >>> a {
  color: #9e5c1d;
  text-decoration: underline;
}
.article-content >>> a:hover { color: #b47f4d; }

/* 代码 */
.article-content >>> code {
  background: #f3e9de;
  color: #634c37;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 14px;
  font-family: 'Courier New', Consolas, monospace;
}
.article-content >>> pre {
  background: #f3e9de;
  padding: 12px 16px;
  border-radius: 4px;
  overflow-x: auto;
}
.article-content >>> pre code {
  background: transparent;
  padding: 0;
}

/* 水平线 */
.article-content >>> hr {
  border: 0;
  border-top: 1px solid #dfc6b2;
  margin: 2em 0;
}

.article-error {
  text-align: center;
  color: #888;
  font-size: 14px;
  padding: 80px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/article/ArticleView.vue